const workspaceKeys = new Set([
    'inteloptics_global_assets',
    'inteloptics_global_notes',
    'inteloptics_organization_access',
    'inteloptics_pending_plan',
    'lms_lesson_plans',
    'msaTestToken',
    'use_mock_data',
]);

const workspacePrefixes = [
    'inteloptics_global_assets:',
    'gemini_cache_',
    'ep_',
    'br_',
    'lim_',
    'lms_generated_module_',
    'checklist_',
    'service_request_template:',
];

export const clearWorkspaceStorage = (storage: Storage): void => {
    for (let index = storage.length - 1; index >= 0; index--) {
        const key = storage.key(index);
        if (key && (workspaceKeys.has(key) || workspacePrefixes.some(prefix => key.startsWith(prefix))))
            storage.removeItem(key);
    }
};

// Remove data saved by older builds without touching unrelated browser settings.
export const clearLegacyWorkspaceData = (): void => {
    try {
        clearWorkspaceStorage(localStorage);
    } catch (error) {
        console.warn('Could not clear legacy workspace data.', error);
    }
};

export const clearClientWorkspaceData = (): void => {
    try {
        clearWorkspaceStorage(sessionStorage);
    } catch (error) {
        console.warn('Could not clear session workspace data.', error);
    }
    clearLegacyWorkspaceData();
};
